'use strict'

module.exports = JSONParse

function JSONParse (text, reviver) {
  try {
    return {
      value: JSON.parse(text, reviver)
    }
  } catch (ex) {
    return {
      error: ex
    }
  }
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/json-parse-safe/index.js
// module id = WV+H
// module chunks = 0